module.exports = __webpack_public_path__ + "img/logo-waterSavings.f4557ea8.svg";